import React, { useState } from 'react';
import axios from 'axios';
import logo from "./assets/logo.png"; 
import adam from "./assets/voice_preview_adam.wav"
import alice from "./assets/voice_preview_alice.mp3"
import antoni from "./assets/voice_preview_antoni.mp3"
import bill from "./assets/voice_preview_bill.mp3"
import elli from "./assets/voice_preview_elli.mp3"
import aIdeZYQ86PeVTKIe5may from "./assets/voice_preview_pınar.mp3"

const speakerSamples = {
  Adam: adam,
  Alice: alice,
  Antoni: antoni,
  Bill: bill,
  Elli: elli,
  Pınar: aIdeZYQ86PeVTKIe5may
};

const Podcast = () => {
  const [inputType, setInputType] = useState('text');
  const [textInput, setTextInput] = useState('');
  const [urlInput, setUrlInput] = useState('');
  const [speaker1, setSpeaker1] = useState('');
  const [speaker1_name, setSpeaker1_name] = useState('');
  const [speaker2, setSpeaker2] = useState('');
  const [speaker2_name, setSpeaker2_name] = useState('');
  const [audioUrl, setAudioUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [podcastHazirlayan, setPodcastHazirlayan] = useState('');
  const [taskId, setTaskId] = useState(null);
  const [taskStatus, setTaskStatus] = useState('');

  const handleInputTypeChange = (event) => {
    setInputType(event.target.value);
  };

  const handleTextInputChange = (event) => {
    setTextInput(event.target.value);
  };

  const handleUrlInputChange = (event) => {
    setUrlInput(event.target.value);
  };

  const handleSpeaker1Change = (event) => {
    setSpeaker1(event.target.value);
  };
  const handleSpeaker1NameChange = (event) => {
    setSpeaker1_name(event.target.value);
  };
  const handleSpeaker2Change = (event) => {
    setSpeaker2(event.target.value);
  };
  const handleSpeaker2NameChange = (event) => {
    setSpeaker2_name(event.target.value);
  };
  const handlePodcastHazirlayanChange = (event) => {
    setPodcastHazirlayan(event.target.value);
  };

  const checkTaskStatus = async (taskId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_PODCAST_STATUS_URL}/${taskId}`);
      console.log("checkTaskStatus içinde status",response.data.status);
      if (response.data.status === 'completed') {
        setTaskStatus('completed');
        return response.data.file_path; // Return file path if completed
      }
      return null;
    } catch (error) {
      console.error('There was an error checking the task status!', error);
      return null;
    }
  };
  console.log("task_id",taskId);
  
  const startPodcastTask = async (formData) => {
    try {
      setLoading(true);
      const response = await axios.post(process.env.REACT_APP_PODCAST_TEXT_EN_URL, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setTaskId(response.data.task_id);
      console.log("Start task response",response.data)
      return response.data.task_id
      
    } catch (error) {
      console.error('There was an error starting the podcast task!', error);
      setLoading(false);
    }
  };
  const startPodcastURL = async (formData) => {
    try {
      setLoading(true);
      const response = await axios.post(process.env.REACT_APP_PODCAST_URL_EN, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setTaskId(response.data.task_id);
      console.log("Start task response",response.data)
      return response.data.task_id
      
    } catch (error) {
      console.error('There was an error starting the podcast task!', error);
      setLoading(false);
    }
  };

  const handleUpload = async (event) => {
    event.preventDefault();
    const input = inputType === 'text' ? textInput : urlInput;
    
    if(inputType==="text"){    
      if (input && speaker1 && speaker2) {
        const formData = new FormData();
        formData.append('text', input);
        formData.append('input_type', inputType);
        formData.append('speaker1', speaker1);
        formData.append('speaker1_name',speaker1_name);
        formData.append('speaker2', speaker2);
        formData.append('speaker2_name',speaker2_name);
        formData.append('podcast_hazirlayan',podcastHazirlayan)
        
        const responsePodcastTask = await startPodcastTask(formData);
        
        if (responsePodcastTask) {
          console.log("Handleruploude if girdi")
          const intervalId = setInterval(async () => {
            const filePath = await checkTaskStatus(responsePodcastTask);
            console.log(filePath)
            console.log("Task statüss",taskStatus)
            if (filePath) {
              clearInterval(intervalId);
              const response = await axios.get(`https://podcast-api.cereinsight.com/download/${responsePodcastTask}`, { responseType: 'blob' });
              const audioBlob = new Blob([response.data], { type: 'audio/mp3' });
              const audioUrl = URL.createObjectURL(audioBlob);
              setAudioUrl(audioUrl);
              setLoading(false);
            }
          }, 5000); 
        }
      } else {
        alert('Please fill in all fields');
      }
    }
    if(inputType==="url"){    
      if (input && speaker1 && speaker2) {
        const formData = new FormData();
        formData.append('urls', urlInput);
        formData.append('input_type', inputType);
        formData.append('speaker1', speaker1);
        formData.append('speaker1_name',speaker1_name);
        formData.append('speaker2', speaker2);
        formData.append('speaker2_name',speaker2_name);
        formData.append('podcast_hazirlayan',podcastHazirlayan)
        
        const responsePodcastTask = await startPodcastURL(formData);
        
        if (responsePodcastTask) {
          console.log("Handleruploude if girdi")
          const intervalId = setInterval(async () => {
            const filePath = await checkTaskStatus(responsePodcastTask);
            console.log(filePath)
            console.log("Task statüss",taskStatus)
            if (filePath) {
              clearInterval(intervalId);
              const response = await axios.get(`https://podcast-api.cereinsight.com/download/${responsePodcastTask}`, { responseType: 'blob' });
              const audioBlob = new Blob([response.data], { type: 'audio/mp3' });
              const audioUrl = URL.createObjectURL(audioBlob);
              setAudioUrl(audioUrl);
              setLoading(false);
            }
          }, 5000); 
        }
      } else {
        alert('Please fill in all fields');
      }      
    }
  };
  const navigateToTurkish = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <div className="place-self-end">
          <button
            onClick={navigateToTurkish}>
            TR
          </button>
        </div>
        <div className="flex justify-center mb-4">
          <img src={logo} alt="Company Logo" className="h-16"/>
        </div>
        <h1 className="text-2xl font-bold mb-4 text-center">Podcast</h1>
        <p className="mb-4 text-center">Enter text or URL, select speakers to podcast the content.</p>
        
        <div className="mb-4">
          <label className="mr-4">
            <input 
              type="radio" 
              value="text" 
              checked={inputType === 'text'} 
              onChange={handleInputTypeChange} 
            />
            Text
          </label>
          <label>
            <input 
              type="radio" 
              value="url" 
              checked={inputType === 'url'} 
              onChange={handleInputTypeChange} 
            />
            URL
          </label>
        </div>

        {inputType === 'text' ? (
          <textarea 
            type="text"
            value={textInput}
            onChange={handleTextInputChange}
            placeholder="Enter text"
            className="mb-4 w-full px-3 py-2 border rounded"
          />
        ) : (
          <input 
            type="text"
            value={urlInput}
            onChange={handleUrlInputChange}
            placeholder="Enter URL"
            className="mb-4 w-full px-3 py-2 border rounded"
          />
        )}

        <div className="mb-4">
          <select 
            value={speaker1}
            onChange={handleSpeaker1Change}
            className="w-full mb-2 px-3 py-2 border rounded"
          >
            <option value="">Select Speaker 1</option>
            <option value="Adam">Adam</option>
            <option value="Alice">Alice</option>
            <option value="Antoni">Antoni</option>
            <option value="Bill">Bill</option>
            <option value="Elli">Elli</option>
            <option value="Pınar">Pınar</option>
          </select>
          {speaker1 && (
            <audio controls src={speakerSamples[speaker1]} className="w-full mb-2"></audio>
          )}
          <input 
            type="text"
            value={speaker1_name}
            onChange={handleSpeaker1NameChange}
            placeholder="Enter Speaker 1 Name"
            className="mb-4 w-full px-3 py-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <select 
            value={speaker2}
            onChange={handleSpeaker2Change}
            className="w-full mb-2 px-3 py-2 border rounded"
          >
            <option value="">Select Speaker 2</option>
            <option value="Adam">Adam</option>
            <option value="Alice">Alice</option>
            <option value="Antoni">Antoni</option>
            <option value="Bilgehan">Bilgehan</option>
            <option value="Bill">Bill</option>
            <option value="Elli">Elli</option>
            <option value="Pınar">Pınar</option>
          </select>
          {speaker2 && (
            speakerSamples[speaker2] && (
              <audio controls src={speakerSamples[speaker2]} className="w-full mb-2"></audio>
            )
          )}
          <input 
            type="text"
            value={speaker2_name}
            onChange={handleSpeaker2NameChange}
            placeholder="Enter Speaker 2 Name"
            className="mb-4 w-full px-3 py-2 border rounded"
          />
        </div>
        <div>
          <input 
            type="text"
            value={podcastHazirlayan}
            onChange={handlePodcastHazirlayanChange}
            placeholder="Enter Podcast Producer"
            className="mb-4 w-full px-3 py-2 border rounded"
          />
        </div>
        <button 
          className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition duration-200"
          onClick={handleUpload}
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Podcast'}
        </button>
        
        {loading && (
          <div className="mt-4 text-center">
            <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full" role="status">
              <span className="visually-hidden"></span>
            </div>
          </div>
        )}
        
        {audioUrl && (
          <div className="mt-4 p-4 border rounded bg-gray-50 relative">
            <h2 className="text-xl font-semibold mb-2">Your Podcast Audio:</h2>
            <audio controls src={audioUrl} className="w-full mb-2"></audio>
            <a 
              href={audioUrl} 
              download="podcast.wav"
              className="w-full bg-green-500 text-white py-2 rounded hover:bg-green-600 transition duration-200 text-center block"
            >
              Download Audio
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Podcast;